var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconPreviousQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 46,
    viewBox: "0 0 51 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9199 40.9369C35.7747 41.0684 35.6023 41.1726 35.4125 41.2438C35.2226 41.3149 35.0191 41.3516 34.8136 41.3516C34.6081 41.3516 34.4046 41.3149 34.2148 41.2438C34.0249 41.1726 33.8525 41.0684 33.7074 40.9369L14.9574 24.0002C14.8119 23.8691 14.6964 23.7133 14.6176 23.5419C14.5389 23.3704 14.4983 23.1866 14.4983 23.0009C14.4983 22.8153 14.5389 22.6315 14.6176 22.46C14.6964 22.2885 14.8119 22.1328 14.9574 22.0017L33.7074 5.06496C34.0008 4.79994 34.3987 4.65105 34.8136 4.65105C35.2285 4.65105 35.6265 4.79994 35.9199 5.06496C36.2133 5.32998 36.3781 5.68943 36.3781 6.06423C36.3781 6.43903 36.2133 6.79847 35.9199 7.0635L18.273 23.0009L35.9199 38.9384C36.0654 39.0695 36.1808 39.2252 36.2596 39.3967C36.3384 39.5682 36.3789 39.752 36.3789 39.9376C36.3789 40.1233 36.3384 40.3071 36.2596 40.4786C36.1808 40.6501 36.0654 40.8058 35.9199 40.9369Z",
    fill: "#B3B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconPreviousQuestion);
export default __webpack_public_path__ + "static/media/TH-Icon-Previous-Question.2a9c27f886e58edca1d0c5cfc80f0c96.svg";
export { ForwardRef as ReactComponent };